import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { STRING } from "../constant";


import { IMAGES } from "../assets";
import { ThemeContext } from "../context/ThemeProvider";
import { MdRefresh } from "react-icons/md";
import { BundleContext } from "../context/BundleProvider";
import { AuthContext } from "../context/AuthProvider";
import { SHOW_TOAST } from "../constant/utils";
import { UPDATE_EXAM_DATA } from "../api/firebase_user";
import BackArrowIcon from "../components/BackArrowIcon";
import { LAText, LAView } from "../components";

function UserExamSchedule() {
  const [value, onChange] = useState(new Date());
  const [selected, setSelected] = useState(new Date());
  const [loading, setLoading] = useState(false); 
  const [nextLoading, setNextLoading] = useState(false); 
  const navigate = useNavigate();
  const location = useLocation();  
  const isFromProfile = location.state?.isFromProfile;
//   const selectedCertificate = location.state?.selectedCertificate;
    const { selectedCertificate } = useContext(BundleContext);
    const { profile, setExamDate } = useContext(AuthContext)
  

  const { exam } = location.state || {};
 
  const { theme, currentTheme, setCurrentTheme } = useContext(ThemeContext);

  const [progress, setProgress] = useState(40); 

  useEffect(() => {  
    
    if (isFromProfile && location.state?.profile?.onboarding_exam_date) {
      const { seconds, nanoseconds } = location.state.profile.onboarding_exam_date;
  
      const validDate = new Date(seconds * 1000 + nanoseconds / 1000000);
  
      if (!isNaN(validDate.getTime())) {
        setSelected(validDate);
      }
    }
  }, [isFromProfile, location.state]);
  
  

  const handleDateChange = (date) => {
    setSelected(date);
  };

//   async function onSubmit() {
//     if (selected) {
//       navigate(-1);
//     } else {
//       alert(`Please select the date for your ${selectedCertificate} Exam`);
//     }
//   }

  const onNext = () => {
    if (!selected) {
      alert(`Please select the date for your ${exam?.title} Exam`);
      return;
    }

    setLoading(true); // Start loading
    
    setProgress(40);

    setTimeout(() => {
      setProgress(60);

      navigate("/start-assesment", {
        state: { exam, exam_date: selected, not_scheduled_yet: 0 },
      });
      setLoading(false); // Stop loading after navigation
    }, 1000);
  };

  function onNotScheduled() {
    setNextLoading(true);
    

    setTimeout(() => {
      navigate("/start-assesment", {
        state: { exam, exam_date: "", not_scheduled_yet: 1 },
      });
      setNextLoading(false); // Stop loading after navigation
    }, 1000);
  }

  async function onSubmit() {
    if (selected) {
        // console.log('>>>>>>>>>>>>>>>>>>>>> selected', selected);
        

        
        setExamDate(selected);
        UPDATE_EXAM_DATA(selected);

        navigate(-1);
    }
    else {
        SHOW_TOAST(`Please select the date for your ${selectedCertificate} Exam`)
    }
}

  const onToggleTheme = () => {
    const body = document.body;
    const newTheme = currentTheme === "light" ? "dark" : "light";
    localStorage.setItem("Theme", newTheme);
    setCurrentTheme(newTheme);
    body.classList.toggle("dark", newTheme === "dark");
  };

  const goBack = () => {
    navigate(-1);
  };

  

  return (
    <>
     {/* <section className="score bg-white dark:bg-black">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-rel">
              <div className="col-set">
                <button onClick={goBack}>
                  {currentTheme === "dark" ? (
                    <svg
                      viewBox="0 0 24 24"
                      className="arrow-img"
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12H19M5 12L11 6M5 12L11 18"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      viewBox="0 0 24 24"
                      className="arrow-img"
                      fill="#000"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12H19M5 12L11 6M5 12L11 18"
                        stroke="#000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  )}
                </button>
               
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* <div className="col-12 mt-4">
          <progress value={progress} max="100" className="w-full">
              {progress}%
          </progress>
      </div>  */}
      <LAView flex="row" className="mb-3 flex items-center px-[24px]">
        <button
          className="rounded-lg border-2 border-[#000] dark:border-[#fff] px-2 py-2"
          onClick={() => {
            navigate(-1);
          }}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? "#101010" : "#fff"}
          />
        </button>
        <LAView flex="col" className="flex-1 mx-6">
          <div className="flex items-center justify-between">
            <LAText
              className="flex line-clamp-1 truncate"
              size="medium"
              font="600"
              color={"black"}
              title={"Exam Date"}
            />

            {/* {!editble ? (
              <button
                className={
                  currentTheme === "light"
                    ? "#101010 border-2 rounded-2xl p-2"
                    : "#fff #101010 border-2 rounded-2xl p-2"
                }
                onClick={() => onEditProfileInfo()}
              >
                <svg
                  stroke="currentColor"
                  fill={currentTheme === "light" ? "#101010" : "#fff"}
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  height="1.3em"
                  width="1.3em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
                </svg>
              </button>
            ) : (
              <button
                className="border-2 border-black rounded-2xl p-2 "
                onClick={() => onSave()}
              >
                <img className="w-6 h-6 filter invert" src={IMAGES?.ic_save} />
              </button>
            )} */}
          </div>
        </LAView>
      </LAView>

      <section className="date bg-white dark:bg-black">
        <div className="container-fluid w-full bg-white dark:bg-black">
          <div className="row">
            <div className="col-12">
              <p className="exam-text-title text-center text-black dark:text-white lg:text-[32px] font-manrope-600">
                {isFromProfile
                  ? STRING.when_is_your_exam_schedule.replace(
                      "exam_name",
                      selectedCertificate
                    )
                  : STRING.when_is_your_exam_schedule.replace(
                      "exam_name",
                      exam?.title
                    )}
              </p>

              <p className="exam-text-desc text-center py-2 px-2 text-gray-500 dark:text-white lg:text-[16px] font-manrope-500">
                Tell us your exam date so we can create a tailored experience
                for you.
              </p>

              {/* Calendar */}
              <div className={`calendar ${currentTheme == 'light' ? 'light-calendar' : 'dark-calendar'}`}>
                <Calendar
                  onChange={handleDateChange}
                  value={selected}
                  minDate={new Date()}
                  tileClassName={({ date }) =>
                    date.toISOString().split("T")[0] ===
                    selected.toISOString().split("T")[0]
                      ? "selected-day"
                      : ""
                  }
                />
              </div>

              <div className="nxtr">
                  <div className="btn-col">
                    <button className="btn-asses flex items-center justify-center text-black dark:text-white lg:text-[16px] font-manrope-600" onClick={onSubmit}>
                    {loading ? <MdRefresh className="animate-spin mr-2" size={20} /> : null}
                    {loading ? "Loading..." : 'Set Exam Date'}
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default UserExamSchedule;
